<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	import dayjs from 'dayjs';
	// Stores
	import CompetitionStore from '@/Stores/Sport/CompetitionStore';
	import ACLStore from '@/Stores/ACLStore.js';
	// Components
	import Datepicker from '@/Components/Datepicker.svelte';
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/NewTextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify';

	export let sport;
	export let open;

	const dispatch = createEventDispatcher();

	let sending = false;
	let errors = null;

	let competitionForm = {
		sport_id: sport.id,
		name: '',
		start_time: '',
		fees: null,
		cashout_enabled: false
	};

	let competitionDateToggle = false;
	let competitionDate = dayjs().format('YYYY-MM-DD');
	let competitionTime = dayjs().format('HH:mm');

	$: competitionStart = dayjs(competitionDate + ' ' + competitionTime + ':00');
	$: competitionStart && updateDateTimes();

	function updateDateTimes() {
		competitionForm.start_time = dayjs(competitionStart).format('YYYY-MM-DDTHH:mm:ssZ');
	}

	function createManualCompetition() {
		sending = true;
		if (!competitionDateToggle) {
			delete competitionForm.start_time;
		}
		if (!$ACLStore && ACLStore.granted('competitions.update.fees')) {
			delete competitionForm.fees;
		}
		CompetitionStore.createCompetition(competitionForm)
			.then(() => {
				notify({
					type: 'success',
					title: 'Manual competition created',
					message: `Manual competition successfully created for ${sport.name}!`,
					timeout: 3
				});
				dispatch('created');
				open = false;
				competitionForm = {
					sport_id: sport.id,
					name: '',
					start_time: '',
					fees: 0,
					cashout_enabled: false
				};
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem creating manual competition',
					timeout: 3
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Create competition for {sport.name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				label="Competition Name"
				name="competitionName"
				className="py-4 w-full text-left"
				errors={errors && errors.name}
				placeholder="Enter new competition name"
				bind:value={competitionForm.name}
			/>
			<div class="text-left mb-4">
				<label class="form-label" for="competitionStartTime"
					>Start Time:
					<Switch name="competitionDateToggle" bind:checked={competitionDateToggle} small={true} className="ml-1" />
				</label>

				<div class="flex flex-row">
					<div class="flex-shrink">
						<Datepicker
							selected={competitionDate}
							disabled={!competitionDateToggle}
							displayFormat="DD-MM-YYYY"
							dateChosen={(date) => {
								competitionDate = dayjs(date).format('YYYY-MM-DD');
							}}
						/>
					</div>
					<TextInput
						bind:value={competitionTime}
						disabled={!competitionDateToggle}
						name="competitionStartTime"
						className={!competitionDateToggle ? 'opacity-50' : ''}
						type="time"
					/>
				</div>
			</div>
			{#if $ACLStore && ACLStore.granted('competitions.update.fees')}
				<TextInput
					label="Competition Fees"
					name="competitionFees"
					suffix="%"
					type="number"
					step="0.01"
					className="pb-4 w-full text-left"
					placeholder="Enter new competition fees"
					bind:value={competitionForm.fees}
				/>
			{/if}
			<div class="flex flex-row mb-2">
				<label class="form-label" for="competitionCashoutEnabled"
					>Cashout enabled:
					<Switch name="competitionCashoutEnabled" bind:checked={competitionForm.cashout_enabled} className="ml-1" />
				</label>
			</div>
			<LoadingButton on:click={() => createManualCompetition()} loading={sending} className="mb-4 btn btn-primary">
				{sending ? 'Creating' : 'Create'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
